import type { ActivityModule } from '../../core/activity';
import { runAlgebraActivity } from '../../shared/algebra-runner';
import type { AlgebraLevel } from '../../shared/algebra-runner';
import levelsData from './levels.json';

export const algebraBy: ActivityModule = {
  id: 'algebra_by',
  title: 'Multiplicação',
  description: 'Treine a tabuada de multiplicação (1 ao 10). Inclui nível final com produtos até 100.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/algebra_by/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount(ctx) {
    return runAlgebraActivity(ctx, {
      activityId: 'algebra_by',
      title: 'Multiplicação',
      operator: '×',
      compute: (a, b) => a * b,
      levels: levelsData.levels as AlgebraLevel[],
    });
  },
};
